import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import UnknownDumbo from '../../Dumbo/Unknown';
import DeviationDumbView from '../../Dumbo';
import s from './Minimal.scss';
var Minimal = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick, width = _a.width, height = _a.height, className = _a.className, style = _a.style;
    return (React.createElement(Flex, { className: classnames(s['root'], onClick && s['clickable-root'], className), alignItems: "center", justifyContent: "center", style: __assign({ width: width, height: height }, style), onClick: onClick },
        deviation && (React.createElement(DeviationDumbView, { className: s['dumbo'], deviation: deviation, width: width, height: height })),
        !deviation && (React.createElement(UnknownDumbo, { className: s['dumbo'], width: width, height: height })),
        React.createElement(TierBadge, { size: 24, className: s['badge'] })));
};
Minimal.displayName = 'Minimal';
export default Minimal;
//# sourceMappingURL=Minimal.js.map